import { useEffect, useState } from "react";
import "../../styles/driver_modal.css";

export default function CarCreateModal({ open, onClose, onSubmit }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    tel: "",
    email: "",
    whatsapp: "",
    adress: "",
    profilPicture: null,
    licenceFront: null,
    licenceBack: null,
  });

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open) return null;

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleFileChange(e) {
    setForm({ ...form, [e.target.name]: e.target.files[0] });
  }

  function handleSubmit(e) {
    e.preventDefault();

    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== "") {
        data.append(key, value);
      }
    });

    onSubmit(data);
  }

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Ajouter un chauffeur</h3>

        <form onSubmit={handleSubmit} className="modalForm">

          {/* Infos générales */}
          <div className="modalSection">
            {/* <div className="modalSectionTitle">Informations générales</div> */}

            <div className="formGrid">
              <Input label="Prénom" name="firstName" required onChange={handleChange} />
              <Input label="Nom" name="lastName" required onChange={handleChange} />
              <Input label="Nom d'utilisateur" name="username" required onChange={handleChange} />
              <Input label="Mot de passe" name="password" type="password" required onChange={handleChange} />
              <Input label="Téléphone" name="tel" required onChange={handleChange} />
              <Input label="Pourcentage" name="orderPercentage" type="number" min="0" max="100" onChange={handleChange} />
              <Input label="Email" name="email" type="email" onChange={handleChange} />
              <Input label="WhatsApp" name="whatsapp" onChange={handleChange} />
              <Input label="Adresse" name="adress" onChange={handleChange} />
            </div>
          </div>

          {/* Documents */}
          {/* <div className="modalSection">
            <div className="modalSectionTitle">Documents</div>

            <div className="formGrid">
              <FileInput
                label="Photo de profil"
                name="profilPicture"
                onChange={handleFileChange}
              />
              <FileInput
                label="Permis (Recto)"
                name="licenceFront"
                onChange={handleFileChange}
              />
              <FileInput
                label="Permis (Verso)"
                name="licenceBack"
                onChange={handleFileChange}
              />
            </div>
          </div> */}

          <div className="modalActions">
            <button type="button" className="btnGhost" onClick={onClose}>
              Annuler
            </button>
            <button className="btnPrimary">
              Créer
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}

function FileInput({ label, name, onChange }) {
  const [preview, setPreview] = useState(null);

  function handleFile(e) {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      onChange(e);
    }
  }

  return (
    <div className="fileUpload">
      <label className="fileLabel">{label}</label>

      <label className="fileDrop">
        {preview ? (
          <img src={preview} alt="preview" className="filePreview" />
        ) : (
          <div className="filePlaceholder">
            <span className="fileIcon">📷</span>
            <span>Cliquer pour ajouter</span>
            <small>PNG, JPG</small>
          </div>
        )}

        <input
          type="file"
          name={name}
          accept="image/*"
          onChange={handleFile}
          hidden
        />
      </label>
    </div>
  );
}

